import programService from "../../services/programService";

const state = {
  programs: [],
  selectedProgram: null,
  programStakeholdersWithSurveys: [],
  programConversations: [],
};

const getters = {
  programs: state => {
    return state.programs;
  }
};

const actions = {
  async getPrograms({ commit }) {
    let programs = await programService.fetchPrograms();
    commit("SET_PROGRAMS", programs);
  },
  async getProgramStakeholdersWithSurveys({ commit }, pk) {
    await programService.getProgramStakeholdersWithSurveys(pk).then(response => {
      commit("SET_PROGRAM_STAKEHOLDERS_WITH_SURVEYS", response.data)
    }).catch(() => {
      commit("SET_PROGRAM_STAKEHOLDERS_WITH_SURVEYS", { stakeholders: "Error", surveys: "Error" })
    })
  },
  async getProgramConversations({ commit }, pk) {
    await programService.getProgramConversations(pk).then(response => {
      commit("SET_PROGRAM_CONVERSATIONS", response.data)
    }).catch(() => {
      commit("SET_PROGRAM_CONVERSATIONS", { conversations: "Error", percentage: "Error" })
    })
  },
  updateSelectedProgram({ commit }, program) {
    commit("UPDATE_SELECTED_PROGRAM", program);
  },
  updateProgram({ commit }, payload) {
    programService.updateProgram(payload).then(program => {
      commit("UPDATE_PROGRAM", program)
    })
  },
};

const mutations = {
  SET_PROGRAMS(state, response) {
    state.programs = response;
  },
  SET_PROGRAM_STAKEHOLDERS_WITH_SURVEYS(state, response) {
    state.programStakeholdersWithSurveys = response;
  },
  SET_PROGRAM_CONVERSATIONS(state, response) {
    state.programConversations = response;
  },
  UPDATE_SELECTED_PROGRAM(state, selectedProgram) {
    state.selectedProgram = selectedProgram;
  },
  UPDATE_PROGRAM(state, program) {
    let programIndex = state.programs.findIndex(programInList => programInList.pk === program.pk)
    state.programs[programIndex].name = program.name;
    state.programs[programIndex].view_multiple_surveys = program.view_multiple_surveys;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
